import Image from 'next/image'
import { EyeIcon } from '@components/icons/EyeIcon'
import { HeartEbookSolidIcon } from '@components/icons/HeartEbookSolidIcon'
import { StarSolidIcon } from '@components/icons/StarSolidIcon'
import { ChatboxIcon } from '@components/icons/ChatboxIcon'
import { BookShelfIcon } from '@components/icons/BookShelfIcon'
import { BookEnum } from '@interfaces/BookEnum'
import { formatAvgRating } from '@lib/utils'
import { EbookProfileCardProps } from './interface'

export function EbookProfileCard({
  title,
  cover,
  chapterCount,
  avgRating,
  commentCount,
  likeCount,
  bookType,
  handleViewClick,
}: EbookProfileCardProps) {
  return (
    <div className='bg-gray-4 dark:bg-dark-8 rounded-lg p-[10px]'>
      <div className='grid grid-cols-[92px_1fr] mobile:grid-cols-[57px_1fr] gap-x-[10px]'>
        <div className='pt-[140.625%] bg-gray-3 dark:bg-dark-9 relative w-full h-full'>
          <Image className='rounded-lg' src={cover} layout='fill' alt={title} />
        </div>
        <div className='text-secondary dark:text-dark-10 p-[10px] flex flex-col justify-between'>
          <div>
            <div className='flex justify-between'>
              <div className='text-[14px]'>
                {bookType === BookEnum.NOVEL ? 'อีบุ๊กนิยาย' : 'อีบุ๊กการ์ตูน'}
              </div>
              <button
                type='button'
                className='flex items-center justify-center w-[30px] h-[30px] border-gray-3 dark:border-dark-10 bg-white dark:bg-transparent text-secondary-1 dark:text-dark-10 rounded-lg'
                onClick={handleViewClick}
              >
                <EyeIcon width='20' height='20' />
              </button>
            </div>
            <div className='font-mitr font-medium'>{title}</div>
          </div>

          <div className='grid grid-cols-[108px_112px_130px_1fr] font-light mobile:hidden'>
            <div className='flex space-x-[5px]'>
              <BookShelfIcon className='text-primary' />
              <span className='text-secondary-1 font-light'>
                {chapterCount.toLocaleString()}
              </span>
            </div>
            <div className='flex space-x-[5px]'>
              <StarSolidIcon className='text-primary' />
              <span className='text-secondary-1 font-light'>
                {formatAvgRating(avgRating)}
              </span>
            </div>
            <div className='flex space-x-[5px]'>
              <ChatboxIcon className='text-primary' />
              <span className='text-secondary-1 font-light'>
                {commentCount.toLocaleString()}
              </span>
            </div>
            <div className='flex space-x-[5px]'>
              <HeartEbookSolidIcon className='text-red' />
              <span className='text-secondary-1 font-light'>
                {likeCount.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-y-[10px] mt-[20px] font-light desktop-tablet:hidden'>
        <div className='flex space-x-[5px]'>
          <BookShelfIcon className='text-primary' />
          <span className='text-secondary-1'>
            {chapterCount.toLocaleString()}
          </span>
        </div>
        <div className='flex space-x-[5px]'>
          <StarSolidIcon className='text-primary' />
          <span className='text-secondary-1'>{formatAvgRating(avgRating)}</span>
        </div>
        <div className='flex space-x-[5px]'>
          <ChatboxIcon className='text-primary' />
          <span className='text-secondary-1'>
            {commentCount.toLocaleString()}
          </span>
        </div>
        <div className='flex space-x-[5px]'>
          <HeartEbookSolidIcon className='text-red' />
          <span className='text-secondary-1'>{likeCount.toLocaleString()}</span>
        </div>
      </div>
    </div>
  )
}
